<!-- BEGIN: Subheader -->
<div class="m-subheader">
  <div class="d-flex align-items-center">
    <div class="mr-auto">
      <h3 class="m-subheader__title">
        {{ 'contract-list.title' | transloco }}
      </h3>
    </div>
    <div>
      <app-contract-new [id]="contractId" (contractSave)="onContractSaved($event)"></app-contract-new>
    </div>
  </div>
</div>

<!-- END: Subheader -->
<div class="m-content">
  <!--Begin::Main Portlet-->
  <div class="row">
    <div class="col-sm-12">
      <div class="m-portlet m-portlet--full-height">
        <div class="m-portlet__body">
          <div class="row m--margin-bottom-10" style="align-items: center;">
            <div class="col-md-3">
              <app-organization-select [(ngModel)]="params.organizationId"
                                       (selectChange)="applyFilters()"></app-organization-select>
            </div>
            <div class="col-md-3">
              <form class="m-form" (ngSubmit)="applyFilters()">
                <div class="m-form__section m-form__section--first">
                  <div class="form-group m-form__group m--margin-top-0">
                    <div class="input-group">
                      <input type="text" required [(ngModel)]="params.number" name="searchText"
                             class="form-control m-input"
                             [placeholder]="'contract-list.searchOrder' | transloco">
                      <span class="input-group-btn">
                        <button class="btn btn-outline-accent" type="submit">
                          {{ 'contract-list.btn.search' | transloco }}
                        </button>
                      </span>
                    </div>
                  </div>
                </div>
              </form>
            </div>

            <div class="col-md-2">
              <hx-date-select [(ngModel)]="params.date" (selectChange)="applyFilters()"></hx-date-select>
            </div>

            <div class="col-md-3">
              <app-suppliers-search [organizationId]="params.organizationId" [(ngModel)]="params.supplierId"
                                    (selectChange)="applyFilters()"></app-suppliers-search>
            </div>

            <div class="col-md-1 text-right">
              <button type="button" (click)="resetFilter()" class="btn btn-outline-primary"
                      [ngbTooltip]="'reset.list' | transloco">
                <label>{{ 'reset.list' | transloco }}</label>
              </button>
            </div>
          </div>


          <p *ngIf="pagination?.allItemCount">{{ 'contract-list.allOrders' | transloco }} {{ pagination.allItemCount }}</p>

          <div class="m_datatable m-datatable--va-top m-datatable m-datatable--default m-datatable--loaded m--margin-top-30 m--margin-bottom-30" *ngIf="list.length && !isLoading.list">
            <table class="m-datatable__table">
              <thead class="m-datatable__head">
              <tr class="m-datatable__row m-datatable__row--head">
                <th class="m-datatable__cell">
                  <span>{{ 'contract-list.identifier' | transloco }}</span>
                </th>
                <th class="m-datatable__cell">
                  <span>{{ 'contract-list.number' | transloco }}</span>
                </th>
                <th class="m-datatable__cell">
                  <span>{{ 'contract-list.organization' | transloco }}</span>
                </th>
                <th class="m-datatable__cell">
                  <span>{{ 'contract-list.name' | transloco }}</span>
                </th>
                <th class="m-datatable__cell">
                  <span>{{ 'contract-list.data' | transloco }}</span>
                </th>
                <th class="m-datatable__cell">
                  <span>{{ 'contract-list.supplier' | transloco }}</span>
                </th>
                <th class="m-datatable__cell">
                </th>
              </tr>
              </thead>
              <tbody class="m-datatable__body">
              <tr *ngFor="let even = even; let i = index; let item of list"
                  class="m-datatable__row" [ngClass]="{ 'm-datatable__row--even': even }">
                <td class="m-datatable__cell">
                  <a [routerLink]="[item.id]">
                    {{ item.id }}
                  </a>
                </td>
                <td class="m-datatable__cell">
                  <a [routerLink]="[item.id]">
                    {{ item.number }}
                  </a>
                </td>
                <td class="m-datatable__cell">
                  {{ item.organization?.title | uiLabel }}
                </td>
                <td class="m-datatable__cell">
                  {{ item.title }} <i *ngIf="item.files && item.files.length > 0" [ngbTooltip]="'contract-list.treaty' | transloco"
                                      class="la la-paperclip"></i>
                </td>
                <td class="m-datatable__cell">
                  {{ item.date | date: 'dd.MM.yyyy' }}
                </td>
                <td class="m-datatable__cell">
                  {{ item.supplier?.name }} <span *ngIf="item.supplier?.uin">({{ item.supplier?.uin }})</span>
                </td>
                <td class="m-datatable__cell text-nowrap text-right" style="min-width: 102px;">
                  <a (click)="updateItem(item)" class="btn btn-outline-primary btn-sm m-btn m-btn--icon" [title]="'contract-list.change' | transloco">
                    <i class="la la-edit"></i>
                  </a>

                  <a (click)="confirmModal(item)" class="btn btn-outline-danger m-btn btn-sm m-btn--icon" [title]="'contract-list.treatyDelete' | transloco">
                    <i class="la la-trash"></i>
                  </a>
                </td>
              </tr>
              </tbody>
            </table>
          </div>

          <hx-loader [length]="list.length" [isLoading]="isLoading.list"></hx-loader>

          <div class="m--align-center" *ngIf="list.length && !isLoading.list && pagination.allItemCount > 0">
            <ngb-pagination [maxSize]="5" [rotate]="true" [collectionSize]="pagination.allItemCount"
                            [(page)]="pagination.currentPage" [pageSize]="pagination.limit" (pageChange)="pageChanged($event)" class="d-flex justify-content-center mt-4">
            </ngb-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--End::Main Portlet-->
</div>
<ng-template #templateRef let-modal>
  <div class="modal-body text-center">
    <p>{{ 'contract.question.delete' | transloco }} {{ selectedContract.number }}?</p>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-danger m--margin-right-10" (click)="deleteItem(selectedContract.id)">{{ 'contract-list.btn.yes' | transloco }}</button>

    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">{{ 'contract-list.btn.no' | transloco }}</button>
  </div>
</ng-template>
